"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const store_1 = require("./context/store");
const i18n_1 = __importDefault(require("./i18n"));
const Tabs_1 = __importDefault(require("./components/Tabs"));
const useWidgetCallback_1 = __importDefault(require("./hooks/useWidgetCallback"));
const BuyWidgetV2 = ({ locale, debug, callback, selectedTab = "buy", initialCrypto, disableAutoSelect, initialFiat, address, lockCrypto, hideTabs, providerPath, passThroughAddress, }) => {
    return (react_1.default.createElement(store_1.Provider, { locale: locale, debug: debug, initialCrypto: initialCrypto, disableAutoSelect: disableAutoSelect, initialFiat: initialFiat, address: address, lockCrypto: lockCrypto, hideTabs: hideTabs, providerPath: providerPath, isBuy: selectedTab === "buy", passThroughAddress: passThroughAddress },
        react_1.default.createElement(i18n_1.default, null,
            react_1.default.createElement(useWidgetCallback_1.default, { callback: callback },
                react_1.default.createElement(Tabs_1.default, { selectedTab: selectedTab })))));
};
exports.default = BuyWidgetV2;
//# sourceMappingURL=BuyWidgetV2.js.map